import GuideLayout from '@/pages/shared/GuideLayout';

export default function GuidePM() {
  return (
    <GuideLayout
      title="プロジェクト管理とは？基本・やり方・必要性を解説｜”おもいむすび”"
      description="プロジェクト管理の基本を初心者向けに解説。プロジェクト管理とは何か、なぜ必要なのか、目的、役割、三大要素（QCD）、主な手法、計画の立て方、体制づくりまで。"
      keywords="プロジェクト管理とは,プロジェクト管理 基本,プロジェクト管理 入門,プロジェクト管理 やり方,プロジェクト管理 目的,プロジェクト管理 三大要素"
      canonical="https://omoimusubi.asia/guides/project-management/"
      h1="プロジェクト管理とは？基本からやり方まで初心者向けに解説"
      subtitle="プロジェクト管理の定義、目的、必要性、三大要素（QCD）について基礎から分かりやすく解説します。"
      relatedFeatures={[
        { label: 'AIタスク分解', path: '/features/ai-task-breakdown/' },
        { label: 'AIガントチャート', path: '/features/ai-gantt/' },
        { label: 'AI日報', path: '/features/ai-daily-report/' },
      ]}
      relatedGuides={[
        { label: 'プロジェクト管理に生成AIを活用する方法', path: '/guides/project-management-ai/' },
        { label: 'WBSとは？作り方とガントチャートとの違い', path: '/guides/wbs/' },
        { label: 'ガントチャートとは？作り方とツールの選び方', path: '/guides/gantt-chart/' },
      ]}
    >
      <div className="not-prose mb-8 rounded-xl overflow-hidden border border-background-200/70">
        <img
          src="https://readdy.ai/api/search-image?query=A%20bright%20modern%20Japanese%20office%20scene%20a%20Japanese%20project%20manager%20a%20woman%20in%20her%2030s%20standing%20confidently%20in%20front%20of%20a%20whiteboard%20with%20a%20well%20organized%20project%20plan%20drawn%20with%20colorful%20markers%20showing%20task%20breakdowns%20timelines%20and%20milestone%20markers%20she%20is%20explaining%20the%20plan%20with%20a%20warm%20smile%20natural%20daylight%20through%20large%20windows%20indoor%20plants%20refreshing%20professional%20Japanese%20corporate%20atmosphere&width=1200&height=600&seq=guide-pm-01&orientation=landscape"
          alt="プロジェクト管理とは - プロジェクト計画を説明する日本人プロジェクトマネージャー"
          className="w-full h-auto"
        />
      </div>
      <section>
        <h2>プロジェクト管理とは</h2>
        <p>プロジェクト管理（Project Management）とは、プロジェクトの目標を達成するために、計画の立案から実行、監視、完了までを統合的に管理する一連の活動です。限られた期間、予算、人員の中で、求められる品質の成果物を確実に作り上げるためのマネジメント手法です。</p>
      </section>

      <section>
        <h2>プロジェクト管理の三大要素（QCD）</h2>
        <p>プロジェクト管理において最も重要な3つの要素は「QCD」と呼ばれます。</p>
        <ul>
          <li><strong>Q（Quality：品質）</strong>：成果物が要求された品質基準を満たしているか</li>
          <li><strong>C（Cost：コスト）</strong>：予算内でプロジェクトを完了できるか</li>
          <li><strong>D（Delivery：納期）</strong>：定められた期日までに成果物を納品できるか</li>
        </ul>
        <p>これら3つの要素はトレードオフの関係にあり、プロジェクトマネージャーはQCDのバランスを取りながらプロジェクトを進めることが求められます。</p>
      </section>

      <section>
        <h2>プロジェクト管理の主なプロセス</h2>
        <ol>
          <li><strong>立ち上げ</strong>：プロジェクトの目的と範囲を明確にする</li>
          <li><strong>計画</strong>：WBS、スケジュール、体制、予算を策定する</li>
          <li><strong>実行</strong>：計画に沿って作業を進める</li>
          <li><strong>監視・コントロール</strong>：進捗を測定し、計画との差異を是正する</li>
          <li><strong>終結</strong>：成果物を引き渡し、プロジェクトを完了する</li>
        </ol>
      </section>

      <section>
        <h2>プロジェクト管理がなぜ必要なのか</h2>
        <p>プロジェクト管理を行わないと、以下のような問題が発生しやすくなります。</p>
        <ul>
          <li>スケジュールの遅延</li>
          <li>予算超過</li>
          <li>品質の低下</li>
          <li>メンバー間の認識のずれ</li>
          <li>課題の放置</li>
          <li>ステークホルダーとのコミュニケーション不足</li>
        </ul>
      </section>

      <section>
        <h2>AIを活用したプロジェクト管理の進化</h2>
        <p>近年では、AIを活用したプロジェクト管理ツールが登場し、タスク分解、スケジュール作成、進捗分析などの作業を自動化できるようになりました。”おもいむすび”では、資料をアップロードするだけでAIがWBSを作成し、ガントチャートを自動生成します。</p>
      </section>
    </GuideLayout>
  );
}